import { useBackButton } from './use-back-button.js';

type BackButtonProps = {
  onBack: () => void;
};

/**
 * The Telegram back button for a part of a screen rather than a whole one: mount it while an
 * inline editor is open and it is shown, unmount it and it is hidden. A tab screen has no back
 * button of its own, so the hook cannot simply live in the screen.
 */
export const BackButton = ({ onBack }: BackButtonProps) => {
  useBackButton(onBack);

  return null;
};
